import config from "../../helpers/config";

const trimTrailingSlash = (value) => String(value || "").replace(/\/+$/, "");
const getApiBaseUrl = () => trimTrailingSlash(config.baseURL);

const buildFileUrl = (filename) => (
    filename ? `${getApiBaseUrl()}/vehicule/files/${encodeURIComponent(filename)}` : ""
);

const getFilenameFromDocumentPath = (path) => {
    const match = String(path || "").match(/\/vehicule\/files\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
};

export const resolveDocumentUrl = (document) => {
    const rawPath = document?.path;
    const filenameFromPath = getFilenameFromDocumentPath(rawPath);

    if (filenameFromPath) {
        return buildFileUrl(document?.filename || filenameFromPath);
    }

    if (rawPath && /^https?:\/\//i.test(rawPath)) {
        return rawPath;
    }

    if (rawPath && rawPath.startsWith("/")) {
        return `${getApiBaseUrl()}${rawPath}`;
    }

    if (rawPath) {
        return rawPath;
    }

    if (document?.filename) {
        return buildFileUrl(document.filename);
    }

    return "";
};

export const isVehiclePhoto = (document) => (
    document?.type === "PHOTO" && Boolean(resolveDocumentUrl(document))
);
